// endpoints
import * as uploadEndPoints from "../constants/endpoints/upload";
// axios
import axios from "../axios/axios";

export const uploadImage = (base64) => {
  return axios({
    url: uploadEndPoints.uploadImage,
    method: "POST",
    data: { image: base64 },
  });
};
